import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Process.css';

const Process: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const steps = [
    {
      number: '01',
      title: 'Análise & Estratégia',
      description: 'Entendemos seu negócio, público-alvo e objetivos. Criamos uma estratégia personalizada para maximizar conversões.',
      icon: '🎯',
      duration: '1-2 dias',
    },
    {
      number: '02',
      title: 'Design & Prototipagem',
      description: 'Criamos layouts modernos e intuitivos, focados na experiência do usuário e na identidade da sua marca.',
      icon: '🎨',
      duration: '3-5 dias',
    },
    {
      number: '03',
      title: 'Desenvolvimento',
      description: 'Codificamos seu site com as melhores tecnologias, garantindo performance, segurança e responsividade.',
      icon: '⚡',
      duration: '7-10 dias',
    },
    {
      number: '04',
      title: 'Testes & Otimização',
      description: 'Testamos tudo minuciosamente e otimizamos para velocidade, SEO e conversões antes do lançamento.',
      icon: '🔍',
      duration: '2-3 dias',
    },
    {
      number: '05',
      title: 'Lançamento & Suporte',
      description: 'Colocamos seu site no ar e oferecemos suporte completo para garantir que tudo funcione perfeitamente.',
      icon: '🚀',
      duration: '1 dia',
    },
  ];

  return (
    <section id="processo" className="process section">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="process-header"
        >
          <h2 className="section-title">
            Nosso Processo Comprovado
          </h2>
          <p className="section-subtitle">
            Um método testado e aprovado que garante resultados excepcionais. 
            Transparência total do início ao fim.
          </p>
        </motion.div>

        <div className="process-timeline">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className={`process-step ${index % 2 === 0 ? 'left' : 'right'}`}
            >
              <div className="step-content">
                <div className="step-header">
                  <div className="step-icon">
                    {step.icon}
                  </div>
                  <div className="step-number">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                
                <div className="step-duration">
                  <span className="duration-icon">⏱️</span>
                  <span className="duration-text">{step.duration}</span>
                </div>
              </div>
              
              <div className="step-connector">
                <div className="connector-dot"></div>
                {index < steps.length - 1 && <div className="connector-line"></div>}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="process-summary"
        >
          <div className="summary-card">
            <h3>⚡ Entrega Rápida</h3>
            <p>Seu site pronto em até <strong>15 dias úteis</strong></p>
          </div>
          
          <div className="summary-card">
            <h3>🛡️ Garantia Total</h3>
            <p><strong>30 dias</strong> de garantia e suporte gratuito</p>
          </div>
          
          <div className="summary-card">
            <h3>📱 Tudo Incluso</h3>
            <p>Hospedagem e SSL <strong>por 1 mês</strong></p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 1.4 }}
          className="process-cta"
        >
          <h3>Pronto para começar seu projeto?</h3>
          <p>Vamos transformar sua ideia em realidade!</p>
          <a href="#contato" className="btn-primary">
            Iniciar Meu Projeto Agora
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Process;